import log from 'lib/log'
import AsyncPage from 'pages/AsyncPage'
import { loadUserProfile } from 'actions/users'
import { isFollowingUser } from 'actions/follow'
import prepareTertiaryContent from './tertiary_content'

// todo: pull up to AsyncPage
import universal from 'react-universal-component'
const component = universal(props => import('./MemberProfilePage'))

class AsyncMemberProfilePage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  createPageHeadInfo(getState, opts, callback) {
    let {
      instance: { value: { domainName, instanceName } },
      user: { value: { username, firstname, lastname, registered, avatar } }
    } = getState()
    return {
      title: username,
      description: `${firstname ? firstname : ''} ${lastname ? lastname : ''}`,
      type: 'profile',
      created: registered,
      firstname,
      lastname,
      instance: instanceName,
      domain: domainName,
      image: avatar
    }
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    try {
      const {
        location: { type: place, payload: { username } },
        user: { value: them },
        session: { value: currentUser }
      } = getState()
      // prevent viewing your own profile as if you were someone else, so that e.g.
      // you never see the follow buttons for yourself ...
      if (currentUser && currentUser.username === username) {
        dispatch({
          type: 'profile/public/posts',
          payload: {},
          meta: {
            location: {
              kind: 'redirect'
            }
          }
        })
      } else {
        let profile = null
        if (them && them.username === username) {
          // no need to reload ?
          profile = them
        } else {
          profile =
            username &&
            (await loadUserProfile({ username })(dispatch, getState, opts))
        }
        if (profile) {
          if (currentUser) {
            try {
              await isFollowingUser({
                entityId: profile._id,
                followerId: currentUser._id
              })(dispatch, getState, opts)
            } catch (followErr) {
              // not following throws a 404 ;)
            }
          }
          await prepareTertiaryContent(profile, place, dispatch, getState, opts)
        }
      }
    } catch (err) {
      log.error(err)
      // let the redux flow deal with this
    }
  }
}

export default new AsyncMemberProfilePage()
